
class MobileMenu {

  /**
  * Constructor function
  *
  * Function that performs actions upon initiation of this class
  *
  * This function registers events for the navigation link used to trigger the mega menu,
  * as well as for the body which is used to detect when the user has clicked off the mega menu.
  * This function also sets the required CSS classes used for displaying the mega menus.
  *
  * @param    object  navMenu   Object containing the navMenu element
  * @return   void
  * @access   public
  */
  constructor(navMenu) {
    this.navMenu      = navMenu;
    this.toggler      = this.navMenu.querySelector('.navbar__toggler');
    this.togglerIcons = this.toggler.querySelectorAll('.navbar__toggler--icon');
    this.collapse     = this.navMenu.querySelector('.navbar__collapse');
    this.arrows       = this.navMenu.querySelectorAll('.nav__arrow');
    this.submenus     = this.navMenu.querySelectorAll('.mega-menu');

    this.toggler.addEventListener('click', () => {
      this._toggleMenu();
    });

    this.arrows.forEach((arrow) => {
      arrow.addEventListener('click', (event) => {
        const menu = event.target.closest('.nav__item').querySelector('ul');
        this._openSubMenu(menu);
      });
    });
  }

  /**
  * Toggle Mobile Menu function
  *
  * Function that toggles the display of the mobile menu
  * when a user clicks on the hamburger menu
  *
  * @return   void
  * @access   private
  */
  _toggleMenu() {
    document.body.classList.toggle('active');
    this.navMenu.classList.toggle('active');
    this.collapse.classList.toggle('d-none');
    this.collapse.classList.toggle('show');

    // Switch the toggle buttons around
    this.togglerIcons.forEach((icon) => {
      if (icon.classList.contains('d-none')) {
        icon.classList.remove('d-none');
      } else {
        icon.classList.add('d-none');
      }
    });

    this._closeSubMenus();
  }

  /**
  * Open Sub Menu Function
  *
  * Function that displays the sub menu items
  * Note: This is done when a user clicks on the associated dropdown arrow
  *
  * @param    object  subMenu   Object containing the chosen sub menu element
  * @return   void
  * @access   private
  */
  _openSubMenu(subMenu) {
    subMenu.classList.toggle('active');
  }

  /**
  * Close Sub Menu Function
  *
  * Function that hides ALL the sub menu items
  * Note: This is used when the user closes the mobile menu
  * to reset the menu back to it's original state
  *
  * @return   void
  * @access   private
  */
  _closeSubMenus() {
    this.submenus.forEach((menu) => {
      menu.classList.remove('active');
    });
  }
}

export default MobileMenu;
